/*
  Bundle variant filter + lock (bundle-builder page only)

  On the bundle page:
  1. Hide products that don't have a variant matching the variant configured in
     the bundle app admin.
  2. For products that DO match, lock their card's weight selector to the allowed
     variant — remove the other options so the shopper can't switch weights.

  The allowed variant name(s) come from the bundle-dashboard app block's root
  (#bundle-dashboard-root[data-allowed-variant-names]) — a single source of truth.
  Each card exposes its variant titles via data-variant-titles.

  Matching mirrors the app's normalizeVariantName: trim + lowercase + collapse
  whitespace, so "1 lb" matches "1  lb" (but not "1lb").
*/
(function () {
  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function getAllowedNames() {
    const root = document.getElementById('bundle-dashboard-root');
    if (!root) return null; // app block not present → don't filter
    if (String(root.dataset.variantFilterEnabled) !== 'true') return null; // filter off
    let names = [];
    try {
      names = JSON.parse(root.dataset.allowedVariantNames || '[]');
    } catch (e) {
      names = [];
    }
    names = (Array.isArray(names) ? names : []).map(normalize).filter(Boolean);
    return names.length ? names : null;
  }

  function cardMatches(card, allowed) {
    let titles = [];
    try {
      titles = JSON.parse(card.dataset.variantTitles || '[]');
    } catch (e) {
      titles = [];
    }
    if (!Array.isArray(titles)) return false;
    return titles.some((t) => allowed.includes(normalize(t)));
  }

  // Lock the card's weight <select> to the allowed variant(s).
  function lockCardVariant(card, allowed) {
    const wrap = card.querySelector('.pcv2__select, .pcv3__select');
    const select = wrap && wrap.querySelector('select');
    // Single-variant cards have no select — they're already fixed to one variant.
    if (!select) return;

    const options = Array.prototype.slice.call(select.options);
    const keep = options.filter((o) => allowed.includes(normalize(o.textContent)));
    if (!keep.length) return; // shouldn't happen (card already matched)

    // Remove every option that isn't the allowed weight.
    options.forEach((o) => {
      if (keep.indexOf(o) === -1) o.remove();
    });

    // Select the allowed variant and notify the card so price / [name=id] update.
    if (select.value !== keep[0].value) {
      select.value = keep[0].value;
    }
    select.dispatchEvent(new Event('change', { bubbles: true }));

    // Make it read-only (no dropdown to open, chevron hidden) but still submittable.
    wrap.classList.add(
      wrap.classList.contains('pcv3__select') ? 'pcv3__select--locked' : 'pcv2__select--locked'
    );
  }

  function apply() {
    const allowed = getAllowedNames();
    if (!allowed) return; // nothing configured to filter by

    document.querySelectorAll('product-card-v2[data-variant-titles], product-card-v3[data-variant-titles]').forEach((card) => {
      const wrapper = card.closest('li') || card;
      const match = cardMatches(card, allowed);
      wrapper.hidden = !match;

      if (match && card.dataset.bundleLocked !== 'true') {
        lockCardVariant(card, allowed);
        card.dataset.bundleLocked = 'true';
      }
    });
  }

  function init() {
    apply();

    // Re-apply when the grid changes (infinite scroll / pagination / filtering).
    const grid = document.querySelector('.main-products-grid__results');
    if (grid && window.MutationObserver) {
      const observer = new MutationObserver(function (mutations) {
        const added = mutations.some((m) => m.addedNodes && m.addedNodes.length > 0);
        if (added) apply();
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  // Run after the deferred product-card-v2.js has upgraded the cards (i.e. on
  // DOMContentLoaded), so dispatching `change` is actually heard by the card.
  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
